import React, {PropsWithChildren} from "react";
import {css, Theme} from "@emotion/react";

import {Text} from "@pg-design/text-module";

export const RowHeaderTitle = (props: PropsWithChildren<{}>) => (
    <Text css={headerTitleStyle} variant="body_copy_2">
        {props.children}
    </Text>
);

const headerTitleStyle = (theme: Theme) => css`
    color: ${theme.colors.gray["800"]};
    font-weight: 700;
`;
import React, {PropsWithChildren} from "react";
import {css, Theme} from "@emotion/react";

import {Text} from "@pg-design/text-module";

export const RowHeaderTitle = (props: PropsWithChildren<{}>) => (
    <Text css={headerTitleStyle} variant="body_copy_2">
        {props.children}
    </Text>
);

const headerTitleStyle = (theme: Theme) => css`
    color: ${theme.colors.gray["800"]};
    font-weight: 700;
`;
